import React, { useState, useRef } from 'react';
import Button from '../../components/Button';
import Notification from '../../components/Notification';
import { ReactComponent as IconDownload } from '../../icons/download.svg';

import { API_ROOT_URL, defaultFetchOptions } from '../../utils/api';
import DownloadFileService from '../../services/download-file-service';

export default function MappingTool() {
	const [isLoadingDownloadSettings, setIsLoadingDownloadSettings] = useState(false);
	const [isLoadingUploadSettings, setIsLoadingUploadSettings] = useState(false);
	const [isLoadingDownloadSettingsAnalysis, setIsLoadingDownloadSettingsAnalysis] = useState(false);
	const [isLoadingMapResponses, setIsLoadingMapResponses] = useState(false);
	const [isLoadingDownloadResults, setIsLoadingDownloadResults] = useState(false);

	const [file, setFile] = useState(null);

	const refFileInput = useRef(null);

	const handleDownloadSettingsClick = () => {
		setIsLoadingDownloadSettings(true);

		DownloadFileService.get('Mapping/DownloadSettings').then(() => {
			setIsLoadingDownloadSettings(false);
		});
	};

	const handleSelectFileButtonClick = () => {
		refFileInput.current.click();
	};

	const handleSelectFileButtonChange = (event) => {
		const [file] = event.target.files;
		if (file.size > 0) setFile(file);
	};

	const handleUploadSettingsClick = () => {
		setIsLoadingUploadSettings(true);

		const formData = new FormData();
		formData.append('file', file);

		fetch(`${API_ROOT_URL}Mapping/UploadSettings`, {
			...defaultFetchOptions,
			headers: {
				Accept: 'application/json',
			},
			method: 'POST',
			body: formData,
		}).then((response) => {
			setIsLoadingUploadSettings(false);
			setFile(null);
		});
	};

	const handleDownloadSettingsAnalysisClick = () => {
		setIsLoadingDownloadSettingsAnalysis(true);

		DownloadFileService.get('Mapping/DownloadSettingsAnalysisReport').then(() => {
			setIsLoadingDownloadSettingsAnalysis(false);
		});
	};
	
	const handleMapResponsesClick = () => {
		setIsLoadingMapResponses(true);

		fetch(`${API_ROOT_URL}Mapping/MapResponses`, {
			...defaultFetchOptions,
			headers: {
				Accept: 'application/json',
			},
			method: 'POST'
		}).then((response) => {
			setIsLoadingMapResponses(false);
		});
	};
	
	const handleDownloadResultsClick = () => {
		setIsLoadingDownloadResults(true);

		DownloadFileService.get('Mapping/DownloadResults').then(() => {
			setIsLoadingDownloadResults(false);
		});
	};

	return (
		<div className="wrapper mapping-tool">
			<Notification>
				Reflects data on the live site (YE) - make changes on the QA after the survey is closed
			</Notification>

			<div className="mapping-tool-navigation">
				<div className="mapping-tool-navigation__step">
					<div className="step-title">1. Download settings</div>
					<Button
						onClick={handleDownloadSettingsClick}
						isLoading={isLoadingDownloadSettings}
						className="button-download"
						hasIcon={true}
					>
						<IconDownload />
						Download Settings
					</Button>
				</div>
				<div className="mapping-tool-navigation__step">
					<div className="step-title">2. Upload and analyze settings</div>
					<Button onClick={handleSelectFileButtonClick} className="button-upload">
						Select File
					</Button>
					<input
						accept=".xlsx"
						className="file-input"
						type="file"
						ref={refFileInput}
						onChange={handleSelectFileButtonChange}
					/>
					<div className="uploaded-file">
						{file ? file.name : "No file selected"}
					</div>
					<Button
						className="button-upload"
						isLoading={isLoadingUploadSettings}
						onClick={handleUploadSettingsClick}
						disabled={file === null}
					>
						Upload Settings
					</Button>
					<Button
						onClick={handleDownloadSettingsAnalysisClick}
						isLoading={isLoadingDownloadSettingsAnalysis}
						className="button-download"
						hasIcon={true}
					>
						<IconDownload />
						Download settings analysis
					</Button>
				</div>
				<div className="mapping-tool-navigation__step">
					<div className="step-title">3. Map responses</div>
					
					<Button
						onClick={handleMapResponsesClick}
						isLoading={isLoadingMapResponses}
						className="button-map"
						hasIcon={true}
					>
						<IconDownload />
						Map responses
					</Button>
				</div>
				<div className="mapping-tool-navigation__step">
					<div className="step-title">4. Download results</div>

					<Button
						onClick={handleDownloadResultsClick}
						isLoading={isLoadingDownloadResults}
						className="button-download"
						hasIcon={true}
					>
						<IconDownload />
						Download Results
					</Button>
				</div>
			</div>
		</div>
	);
}
